import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import BuildIndicator from "@/components/BuildIndicator";

import Membresias from "@/pages/Membresias";
import Login from "@/pages/Login";
import RegistroMembresia from "@/pages/RegistroMembresia";
import MiMembresia from "@/pages/MiMembresia";
import AdminCanjes from "@/pages/AdminCanjes";
import MembresiaLanding from "@/pages/MembresiaLanding";
import MembresiaAnualBronce from "@/pages/MembresiaAnualBronce";
import IncentiveProgram from "@/pages/IncentiveProgram";
import LinksPage from "@/pages/LinksPage";

const queryClient = new QueryClient();

const AppContent = () => {
  return (
    <Routes>
      {/* Home */}
      <Route path="/" element={<Membresias />} />
      <Route path="/membresias" element={<Navigate to="/" replace />} />

      {/* Landings */}
      <Route path="/membresia" element={<MembresiaLanding />} />
      <Route path="/membresia-anual-bronce" element={<MembresiaAnualBronce />} />

      {/* Auth */}
      <Route path="/login" element={<Login />} />
      <Route path="/registro-membresia" element={<RegistroMembresia />} />

      {/* Hubs */}
      <Route
        path="/mi-membresia"
        element={
          <ProtectedRoute>
            <MiMembresia />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/canjes"
        element={
          <ProtectedRoute requireAdmin>
            <AdminCanjes />
          </ProtectedRoute>
        }
      />
      
      {/* Documents */}
      <Route path="/programa-incentivos" element={<IncentiveProgram />} />

      {/* Link in Bio */}
      <Route path="/links" element={<LinksPage />} />

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/membresias" replace />} />
    </Routes>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      {/* TODO: Remove when Membresias + landings are 100% Spanish-only */}
      <LanguageProvider>
        <BrowserRouter>
          <AuthProvider>
            <div>
              <Toaster />
              <Sonner />
              <AppContent />
              {import.meta.env.DEV && <BuildIndicator />}
            </div>
          </AuthProvider>
        </BrowserRouter>
      </LanguageProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;

